<template>
  <div class="animated fadeIn" id="list-decomptes">
    <transition name="fade">
      <b-card no-body style="min-height: 75vh;">
        <div slot="header">
          <i class="fa fa-justify mr-2"></i>
          <strong>Gestion des types de pièce jointe</strong>
        </div>
        <b-card-body class="small-padding">
          <b-row class="mb-2">
            <b-col lg="4" md="6" sm="8">
              <b-form-group
                label-for="categorie"
                :label-cols="3"
                :horizontal="true">
                <template slot="label"><b>Catégorie</b></template>
                <b-form-select id="categorie" v-model="selectedType" 
                  @change="typeChanged"
                  :options="typesPrincipaux">
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="8">
              <b-button size="md" variant="success" @click="initModal('creationCategorie')" class="mr-2"><i class="fa fa-plus"></i> Créer une nouvelle catégorie</b-button>
            </b-col>
          </b-row>
          <b-row v-if="selectedType" class="mt-5">
            <b-col lg="8" md="10" sm=12>
              <h5 class="d-inline-block">Liste des types de pièces jointes de la catégorie : </h5>
              <span class="like-input ml-3">
                <span class="like-input-text">{{ libelleCategorie }}</span>
                <span class="inner-action">
                  <b-dropdown id="dropdown-dropup-cat" dropup right size="sm" text="⋮" variant="link" no-caret boundary="window">
                    <template #button-content>
                      ⋮<span class="sr-only">actions</span>
                    </template>
                    <b-dropdown-item @click="initModal('modificationCategorie')"><i class="fa fa-pencil"></i> Modifier</b-dropdown-item>
                    <b-dropdown-item @click="deleteType()"><i class="fa fa-trash text-danger"></i> Suprimer</b-dropdown-item>
                  </b-dropdown>
                </span>
              </span>
              <b-table class="table-type-pj mt-1" hover :items="typesSecondaires" :fields="fields" primary-key="id">
                <template #head(action)="data">
                  <b-button v-if="selectedType" size="sm" variant="success" @click="initModal('creationType')" class="ml-2"><i class="fa fa-plus"></i> Ajouter doc.</b-button>
                </template>
                <template #cell(action)="data">
                  <b-dropdown id="dropdown-dropup" dropup right size="sm" text="⋮" variant="link"  class="ml-1 action-button" no-caret boundary="window">
                    <template #button-content>
                      ⋮<span class="sr-only">actions</span>
                    </template>
                    <b-dropdown-item @click="initModal('modificationType',data.item)"><i class="fa fa-pencil"></i> Modifier</b-dropdown-item>
                    <b-dropdown-item @click="initTransfert(data.item)"><i class="fa fa-arrows-h"></i> Changer de catégorie</b-dropdown-item>
                    <b-dropdown-item @click="deleteType(data.item)"><i class="fa fa-trash text-danger"></i> Suprimer</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </transition>

    <b-modal id="modal-type-pj" centered no-close-on-esc no-close-on-backdrop hide-header-close ref="modal-type-pj" :title="titleModal">
      <b-form>
        <div>
          <b-form-group
            label-for="libelleType"
            :label-cols="4"
            :horizontal="true">
            <template slot="label"><b>Libellé :</b></template>
            <b-form-input id="libelleType" type="text" v-model="libelleType" :class="{hasError: errors.libelleType !== ''}">
            </b-form-input>
            <span class="field-error">{{ errors.libelleType }}</span>
          </b-form-group>
        </div>
        <div>
          <b-form-group
            label-for="libelleCourtType"
            :label-cols="4"
            :horizontal="true">
            <template slot="label"><b>Libellé court :</b></template>
            <b-form-input id="libelleCourtType" type="text" v-model="libelleCourtType" :class="{hasError: errors.libelleCourtType !== ''}">
            </b-form-input>
            <span class="field-error">{{ errors.libelleCourtType }}</span>
          </b-form-group>
        </div>
        <div>
          <b-form-group
            label-for="libelleTechniqueType"
            :label-cols="4"
            :horizontal="true">
            <template slot="label"><b>Libellé technique :</b></template>
            <b-form-input id="libelleTechniqueType" type="text" v-model="libelleTechniqueType" :class="{hasError: errors.libelleTechniqueType !== ''}" :disabled="action !== 'creationType' && action !== 'creationCategorie' && !isEmpty(libelleTechniqueType)">
            </b-form-input>
            <span class="field-error">{{ errors.libelleTechniqueType }}</span>
          </b-form-group>
        </div>
        <div>
          <b-form-group label="Type">
            <multiselect v-model="types"
                         :class="{hasError: errors.types !== ''}"
                         tag-placeholder="Choisissez un type"
                         placeholder="Choisissez un type"
                         label="name"
                         track-by="id"
                         :options="allDossierTypes"
                         :multiple="true"
                         :taggable="true">
            </multiselect>
            <span class='field-error'>{{ errors.types }}</span>
          </b-form-group>
        </div>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="primary" class="float-right ml-2" @click="save"><i class="fa fa-save mr-1"></i>Enregistrer</b-button>
          <b-button variant="secondary" class="float-right" @click="cancelModifCategorie"><i class="fa fa-times mr-1"></i>Annuler</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-change-categorie" centered no-close-on-esc no-close-on-backdrop hide-header-close ref="modal-change-categorie" title="Changer la catégorie du type de document">
      <b-form>
        <div>
          <b-form-group
            label-for="categorie"
            :label-cols="3"
            :horizontal="true">
            <template slot="label"><b>Catégorie</b></template>
            <b-form-select id="categorie" v-model="newParentId" 
              :options="typesChangementCat"
              :class="{hasError: errors.newParentId !== ''}">
            </b-form-select>
            <span class="field-error">{{ errors.newParentId }}</span>
          </b-form-group>
        </div>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="primary" class="float-right ml-2" @click="transferer()"><i class="fa fa-save mr-1"></i>Enregistrer</b-button>
          <b-button variant="secondary" class="float-right" @click="cancelChangeCategorie"><i class="fa fa-times mr-1"></i>Annuler</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper"
import {isEmpty} from "@/utils/fileHelper";
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      isEmpty,
      titleModal: 'Gestion de la catégorie',
      allTypes: [],
      typesPrincipaux: [],
      typesChangementCat: [],
      typesSecondaires: [],
      libelleCategorie: '',
      selectedType: null,
      parentId: null,
      newParentId: null,
      libelleType: '',
      libelleTechniqueType: '',
      libelleCourtType: '',
      typeDossier: [],
      allDossierTypes: [],
      selectedTypes: [],
      types: [],
      typeToModify: null,
      typeToTransfert: null,
      action: '',
      fields: [{ key: 'libelle', label: 'Libellé', class: 'text-nowrap'},
        { key: 'type_dossier', label: 'Type de dossier', class: 'action-sm', formatter: (value, key, item) => {
              return value.split(',').join(' , ');
            }
        },
        { key: 'action', label: '', class: 'text-right action-sm', tdClass: 'pr-0'},
      ],
      errors: {
        libelleType: '',
        libelleCourtType: '',
        libelleTechniqueType: '',
        types: '',
        newParentId: '',
      }
    }
  },
  watch: {
    types: function () {
      if (this.types) {
        this.selectedTypes = this.types.map(item => item.id);
      } else {
        this.selectedTypes = [];
      }
    },
    // libelleTechniqueType: function () {
    //   console.log('dans le watch')
    //   console.log(this.action, isEmpty(this.libelleTechniqueType), this.action !== 'creationType' && !isEmpty(this.libelleTechniqueType))
    // }
  },
  mounted() {
    this.getTypesPiecesJointes();
    this.getTypes();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    getTypesPiecesJointes() {
      return new Promise( async (resolve, reject) => {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get("/espaceGestion/types-pieces-jointes")
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.allTypes = response.data.types;
            this.parentTypes = _.filter(response.data.types, (type) => type.parent_id === null);
            this.typesPrincipaux = [];
            for (let type of this.parentTypes) {
              this.typesPrincipaux.push({value: type.id, text: type.libelle});
            }
            resolve();
          })
          .catch(function(error){
            console.log(error)
            self.$store.commit('IS_LOADING', false)
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
            reject(error);
          });
      });
    },
    typeChanged() {
      this.disableSousType = this.selectedType === 5;
      this.typesSecondaires = [];
      const typePj = _.find(this.parentTypes, (type) => type.id === this.selectedType);
      this.libelleCategorie = typePj.libelle;
      for (let type of this.allTypes) {
        if (type.parent_id === this.selectedType) {
          this.typesSecondaires.push(type);
        }
      }
    },
    initModal(action,type) {
      let categorie = {};
      this.clearForm();
      this.action = action;
      if (action === 'modificationCategorie') {
        type = _.find(this.parentTypes, (type) => type.id === this.selectedType);
        this.typeToModify = type;
        this.parentId = type.parent_id;
        this.libelleType = type.libelle
        this.libelleTechniqueType = type.libelle_technique;
        this.libelleCourtType = type.libelle_court;
        this.selectedTypes = type.type_dossier.toLowerCase().split(',');
        this.populateTypes();
      } else if (action === 'modificationType') {
        this.titleModal = 'Gestion du type';
        categorie = _.find(this.parentTypes, (type) => type.id === parseInt(this.selectedType,10));
        this.typeToModify = type;
        this.parentId = categorie.id;
        this.libelleType = type.libelle;
        this.libelleTechniqueType = type.libelle_technique;
        this.libelleCourtType = type.libelle_court;
        this.selectedTypes = [];
        for (let typeDossier of type.type_dossier.toLowerCase().split(',')) {
          if (!isEmpty(typeDossier)) {
            this.selectedTypes.push(typeDossier);
          }
          // console.log('typeDossier',typeDossier)
        }
        // console.log('this.selectedTypes',this.selectedTypes)
        this.populateTypes();
      } else if (action === 'creationType') {
        this.titleModal = 'Création du type de document';
        this.typeToModify = null;
        categorie = _.find(this.parentTypes, (type) => type.id === this.selectedType);
        this.parentId = categorie.id;
      }
      this.$refs['modal-type-pj'].show();
    },
    initTransfert(type) {
      this.clearError();
      this.typeToTransfert = type;
      this.typesChangementCat = [];

      for (let typeParent of this.parentTypes) {
        if (typeParent.id !== type.parent_id) {
          this.typesChangementCat.push({value: typeParent.id, text: typeParent.libelle});
        }
      }
      this.$refs['modal-change-categorie'].show();
    },
    transferer() {
      if (this.validateChangeCategorie()) {
        let self = this;
        let dataPost = {
          'newParentId': this.newParentId,
          'typeId': !isEmpty(this.typeToTransfert) ? this.typeToTransfert.id : null,
        }
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .post('/espaceGestion/types-pieces-jointes/changeCategorie', dataPost)
          .then(async response => {
            this.$store.commit('IS_LOADING', false);
            let action = this.action;
            this.clearError();
            await this.getTypesPiecesJointes();
            this.$refs['modal-change-categorie'].hide();
            this.typeChanged();
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de l\'enregistrement, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    save() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          'libelle': this.libelleType,
          'libelle_court': this.libelleCourtType,
          'libelle_technique': this.libelleTechniqueType,
          'parentId': this.parentId,
          'types': this.selectedTypes,
          'typeId': !isEmpty(this.typeToModify) ? this.typeToModify.id : null,
        }
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .post('/espaceGestion/types-pieces-jointes/save', dataPost)
          .then(async response => {
            this.$store.commit('IS_LOADING', false);
            let action = this.action;
            this.clearForm();
            this.clearError();
            await this.getTypesPiecesJointes();
            this.$refs['modal-type-pj'].hide();
            if (action === 'creationCategorie' || action === 'modificationCategorie') {
              this.selectedType = response.data.type.id;
              this.libelleCategorie = response.data.type.libelle;
              this.typeChanged();
            } else if (action === 'creationType' || action === 'modificationType') {
              this.selectedType = dataPost.parentId;
              this.typeChanged();
            }
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false);
            let textError = 'Une erreur est survenue lors de l\'enregistrement, si le problème persiste merci de faire un ticket au support DOSI';
            if (!isEmpty(error) && error.response && error.response.status === 424) {
              textError = error.response.data.message;
            }
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: textError,
              showConfirmButton: false,
              timer: 6000
            });
          });
      }
    },
    getTypes() {
      let self = this
      // this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/administration/statuts/typesStatus")
        .then(response => {
          console.log(response.data.data)
          // this.$store.commit("IS_LOADING", false)
          for(let type of response.data.data){
            this.allDossierTypes.push({id: type.libelle_technique.toLowerCase(), name: type.libelle})
          }
        })
        .catch(function() {
          // self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        });
    },
    populateTypes() {
      this.types = [];
      for (let selectedType of this.selectedTypes) {
        let name = "";
        for (let type of this.allDossierTypes) {
          console.log(type.name.toLowerCase(), selectedType.toLowerCase())
          if (type.id.toLowerCase() === selectedType.toLowerCase()) {
            name = type.name;
            console.log('name',name)
          }
        }
        this.types.push({id: selectedType.toLowerCase(), name: name});
      }
    },
    deleteType(type) {
      let self = this;
      let text = 'Voulez-vous vraiment supprimer ce type de pièce jointe ?';
      if (isEmpty(type)) {
        text = 'Voulez-vous vraiment supprimer cette catégorie de pièce jointe ? Attention tous les types de pièce jointe rattachés à cette catégorie seront également supprimés !';
      }
      let typeId = !isEmpty(type) ? type.id : this.selectedType;
      // console.log('typeId',typeId)
      this.$swal
        .fire({
          title: 'Êtes-vous sûr?',
          text: text,
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: '#ff1744',
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer'
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit('IS_LOADING', true);
            this.$axios
              .get('/espaceGestion/types-pieces-jointes/delete/'+typeId).then(async response => {
                this.$store.commit('IS_LOADING', false);
                await this.getTypesPiecesJointes();
                if (isEmpty(type)) {
                  this.clearForm();
                  this.selectedType = null;
                } else {
                  this.typeChanged();
                }
              })
              .catch(function(error) {
                  self.$store.commit('IS_LOADING', false)
                  console.log(error)
                  let errorText = 'Une erreur est survenue, lors de la suppression du canal. Si le problème persiste, merci de faire un ticket au support DOSI.'
                  if (error.response.status === 403) { errorText = 'Vous n\'êtes pas autorisé à effectuer cette action' }
                  if (error.response.status === 424) { errorText = error.response.data.message }
                  self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  text:errorText,
                  showConfirmButton: false,
                  timer: 6000
                })
              })
          }
        })
    },
    validate() {
      let valid = true;
      this.clearError();
      // console.log('this.selectedTypes',this.selectedTypes)
      if (isEmpty(this.libelleType)) {
        this.errors.libelleType = 'Le libelle est obligatoire';
        valid = false;
      }
      if (isEmpty(this.libelleCourtType)) {
        this.errors.libelleCourtType = 'Le libelle court est obligatoire';
        valid = false;
      }
      if (isEmpty(this.libelleTechniqueType)) {
        this.errors.libelleTechniqueType = 'Le libelle technique est obligatoire (sans accent ni majuscule et un _ à la place de l\'espace';
        valid = false;
      }

      if (isEmpty(this.selectedTypes)) {
        this.errors.types = 'Le type de dossier correspondant est obligatoire';
        valid = false;
      }

      return valid;
    },
    validateChangeCategorie() {
      let valid = true;
      this.clearError();
      if (isEmpty(this.newParentId)) {
        this.errors.newParentId = 'Vous devez choisir une nouvelle catégorie.';
        valid = false;
      }

      return valid;
    },
    cancelModifCategorie() {
      const typePj = _.find(this.parentTypes, (type) => type.id === this.selectedType);
      if (!isEmpty(typePj)) {
        this.libelleCategorie = typePj.libelle;
      }
      this.libelleType = '';
      this.types = [];
      this.parentId = null;
      this.$refs['modal-type-pj'].hide();
    },
    cancelChangeCategorie() {
      this.clearForm();
      this.$refs['modal-change-categorie'].hide();
    },
    clearForm() {
      this.clearError();
      this.types = [];
      this.typesChangementCat = [];
      this.libelleType = '';
      this.libelleCourtType = '';
      this.libelleTechniqueType = '';
      this.parentId = null;
      this.newParentId = null;
      this.typeToModify = null;
      this.typeToTransfert = null;
      this.action = '';
    },
    clearError() {
      this.errors.libelleType = '';
      this.errors.libelleCourtType = '';
      this.errors.libelleTechniqueType = '';
      this.errors.types = '';
      this.errors.newParentId = '';
    },
  }
}
</script>
<style type="text/css">
  .table-type-pj td {
    padding: 0.1rem 0.75rem;
  }
  .action-button button {
    font-weight: bold;
    border-left: 1px solid #c8ced3;
    border-radius: 0;
    padding-right: 0.8rem;
    padding-left: 0.8rem;
  }
  .like-input {
    display: inline-block;
    height: calc(1.5em + 0.75rem + 2px);
    
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #5c6873;
    vertical-align: middle;
    background-color: #fff;
    border: 1px solid #e4e7ea;
    border-radius: 0.25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  .like-input .like-input-text {
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  }
  .like-input .inner-action {
    display: inline-block;
    padding: 0.15rem 0.35rem;
    border-left: 1px solid #e4e7ea;
  }
  .custom-type-pj-input {
    width: 80%;
    display: inline-block;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
